import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import AiotPlatform from '../views/AiotPlatform.vue'
import IndustrialIot from '../views/IndustrialIot.vue'
import DigitalTransformation from '../views/DigitalTransformation.vue'
import CarbonManagement from '../views/CarbonManagement.vue'
import EquipmentMaintenance from '../views/EquipmentMaintenance.vue'
import AboutUs from '../views/AboutUs.vue'
import SmeDigital from '../views/SmeDigital.vue'
import SmeDigitalTransformation from '../views/SmeDigitalTransformation.vue'
import DigitalMachine from '../views/DigitalMachine.vue'
import CarbonSystemConstruction from '../views/CarbonSystemConstruction.vue'
import FactoryCarbonManagement from '../views/FactoryCarbonManagement.vue'
import Solutions from '../views/Solutions.vue'
import ProductResearch from '../views/ProductResearch.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/aiot-platform',
    name: 'AiotPlatform',
    component: AiotPlatform
  },
  {
    path: '/industrial-iot',
    name: 'IndustrialIot',
    component: IndustrialIot
  },
  {
    path: '/digital-transformation',
    name: 'DigitalTransformation',
    component: DigitalTransformation
  },
  {
    path: '/carbon-management',
    name: 'CarbonManagement',
    component: CarbonManagement
  },
  {
    path: '/carbon-asset-management',
    name: 'CarbonAssetManagement',
    component: CarbonManagement
  },
  {
    path: '/equipment-maintenance',
    name: 'EquipmentMaintenance',
    component: EquipmentMaintenance
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: AboutUs
  },
  {
    path: '/sme-digital',
    name: 'SmeDigital',
    component: SmeDigital
  },
  {
    path: '/sme-digital-transformation',
    name: 'SmeDigitalTransformation',
    component: SmeDigitalTransformation
  },
  {
    path: '/digital-machine',
    name: 'DigitalMachine',
    component: DigitalMachine
  },
  {
    path: '/oa-system',
    name: 'OASystem',
    component: DigitalMachine
  },
  {
    path: '/carbon-system-construction',
    name: 'CarbonSystemConstruction',
    component: CarbonSystemConstruction
  },
  {
    path: '/factory-carbon-management',
    name: 'FactoryCarbonManagement',
    component: FactoryCarbonManagement
  },
  {
    path: '/solutions',
    name: 'Solutions',
    component: Solutions
  },
  {
    path: '/product-research',
    name: 'ProductResearch',
    component: ProductResearch
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 强制所有页面切换都立即回到顶部
    return { x: 0, y: 0 }
  }
})

export default router